import { CSSProperties } from 'react'

const styles = {
  productImageLarge: {
    maxHeight: '375px',
    position: 'relative',
    borderRadius: 10
  } as CSSProperties,
  productImageSmall: {
    maxHeight: '200px',
    position: 'relative',
    borderRadius: 10
  } as CSSProperties,
  title: {
    paddingTop: 20,
    paddingBottom: 10
  } as CSSProperties
}

export default styles
